import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react'
import './Styles/main.css'
import 'notyf/notyf.min.css';
import RoutesPage from './Routes'

const App = () => {
  return (
    <>
      <RoutesPage />
    </>
  )
}

export default App